import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { INVOICES_GET_ONE } from 'api/query-keys.ts';
import type { InvoiceRes } from 'api/swagger';

export const useGetInvoice = (id?: number) => {
  return useQuery<InvoiceRes>({
    queryKey: [INVOICES_GET_ONE, id],
    queryFn: async () => {
      const { data } = await http.get<InvoiceRes>(`/v1/invoices/${id}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 20 * 1000,
    enabled: !!id,
  });
};
